/* eslint no-console:0 */

import Rails from "@rails/ujs";
import Turbolinks from "turbolinks";

Rails.start();
Turbolinks.start();

const images = require.context('../images', true)

import "../src/application.scss";

document.addEventListener('turbolinks:load', async () => {
    handleActivateButtons();
    handleCopyButtons();
    const tasks = [loadRangeInputs()];

    if (document.getElementById('excerpt-qr-container')) {
        tasks.push(loadQrCodes());
    }

    if (document.getElementById('book_authors_container') || document.querySelector('[data-uppy]')) {
        tasks.push(loadPublicationForms());
    }

    if (document.getElementById('tlc_cover_uppy_dashboard') || document.getElementById('tlc_assets_uppy_dashboard')) {
        tasks.push(loadTlcForms());
    }

    await Promise.all(tasks);
});

function handleCopyButtons() {
    $('.button.copy-to-clipboard').on('click', function(e) {
        let $button = $(this);
        let v = $button.data('clipboardText');

        loadClipboardHelpers().then(({copyTextToClipboard}) => copyTextToClipboard(v)).then(function() {
            $button.html("Copied");
            setTimeout(() => { $button.html("Copy") }, 4000);
        }, function() {
            $button.html("Couldn't copy :(");
            setTimeout(() => { $button.html("Copy") }, 4000);
        });
    });
}

function handleActivateButtons() {
    $('.button.activate-client-excerpt').on('click', function(e) {
        let $button = $(this);
        const excerptUrl = $button.data('excerptUrl');

        fetch(excerptUrl)
            .then(function() {
                $button.html("Activated");
                let current_url = window.location.href.replace(/#.*$/, "");
                const redirect_url = current_url + '#client-urls';
                location.href = redirect_url;
                location.reload();
            })
            .catch(function(){
                $button.html("Failed");
            });
    });
}

async function loadClipboardHelpers() {
    return import("./excerpts.js");
}

async function loadQrCodes() {
    const {handleQrCodes} = await import("./excerpts.js");
    handleQrCodes();
}

async function loadPublicationForms() {
    const {
        setupExcerptsForm,
        setupContentFileUppy,
        setupImageUppy
    } = await import("./publications.js");

    setupExcerptsForm();

    document.querySelectorAll('[data-uppy]').forEach(element => {
        if (element.hasAttribute('data-image-select')) {
            setupImageUppy(element);
        } else if (element.hasAttribute('data-epub-select')) {
            setupContentFileUppy(element);
        }
    });
}

async function loadTlcForms() {
    const {setupTlcForms} = await import("./tlc.js");
    setupTlcForms();
}

async function loadRangeInputs() {
    const {updateRangeValueDisplay} = await import("./my-settings");
    updateRangeValueDisplay();
}


/* helpers for association add/remove buttons */
$(document).on('turbolinks:load', function() {
    $('form').on('click', '.add_fields', function(event) {
        const $associationContainer = $(this).prev();

        let regexp, time;
        time = new Date().getTime();
        regexp = new RegExp($(this).data('id'), 'g');
        $associationContainer.append($(this).data('fields').replace(regexp, time));
        return event.preventDefault();
    });
});
